import React from "react";

/**
 * Global app footer — visible on every page (scan workspace, profile,
 * review, marketing landing).
 *
 *   • "RMC Tech"                — shown on every viewport.
 *   • "Built in Chicago, Illinois" — desktop-only (≥sm), hidden on mobile
 *     to preserve real estate.
 */
const AppFooter = () => (
  <footer
    data-testid="app-footer"
    className="w-full border-t border-white/[0.06] mt-12"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#94a3b8]">
      <span
        data-testid="footer-signature"
        className="text-[#cbd5e1] leading-snug"
      >
        © 2026 RMC Tech. CMH{" "}
        <span className="text-[#FF0033]">//</span> Chaos Media Hub. All rights reserved.
      </span>
      <span
        data-testid="footer-location"
        className="hidden sm:inline-flex items-center gap-1.5 shrink-0"
      >
        Built in Chicago, Illinois
      </span>
    </div>
  </footer>
);

export default AppFooter;
